// Redux
import { DialingCodeAction } from './actions';
// Constants
import { DialingCodeState, LOCATION_DIALING_CODE_FAIL, LOCATION_DIALING_CODE_START, LOCATION_DIALING_CODE_SUCCESS } from './types';

const INITIAL_STATE: DialingCodeState = {
    loadingState: 'UNINITIALISED',
    locationDialingCodeData: null
};

export const reducer = (
    state = INITIAL_STATE,
    action: DialingCodeAction
): DialingCodeState => {
    switch (action.type) {
        case LOCATION_DIALING_CODE_START:
            return {
                ...state,
                loadingState: 'LOADING'
            };

        case LOCATION_DIALING_CODE_SUCCESS:
            return {
                ...state,
                loadingState: 'LOADED',
                locationDialingCodeData: action.payload
            };

        case LOCATION_DIALING_CODE_FAIL:
            return {
                ...state,
                loadingState: 'ERROR'
            };

        default:
            return state;
    }
};